<template>
  <div id="feedback-list">
    <form class="row search-pannel" :class="{ fold: fold}" @submit.prevent="doLoad(true)">
      <input type="submit" style="display:none" />
      <div class="col-sm-6">
        <el-input size="small" v-model="query.keyword" placeholder="反馈关键字" />
      </div>
      <div class="col-sm-6">
        <el-input size="small" v-model="query.companyName" placeholder="反馈客户" />
      </div>
      <div class="col-sm-6">
        <el-select size="small" v-model="query.type" placeholder="反馈类型" clearable>
          <el-option v-for="ft in feedTypes" :key="ft.id" :label="ft.name" :value="ft.id"></el-option>
        </el-select>
      </div>
      <div class="col-sm-6 folder">
        <el-button type="primary" size="small" @click="doLoad(true)">确定</el-button>
        <el-button type="default" size="small" @click="doReset">重置</el-button>
        <el-button style="float: right" size="small" type="text" @click="fold = !fold">
          {{ fold ? '展开' : '收起' }}
          <i v-if="fold" class="crm-icon-arrow-down" />
          <i v-else class="crm-icon-arrow-up" />
        </el-button>
      </div>
    </form>
    <div class="data-header">
      <div class="row" :style="{ paddingRight: hasScroll ? 10 + scrollBarWidth + 'px' : 'px' }">
        <div class="col-sm-3">反馈时间</div>
        <div class="col-sm-2">类型</div>
        <div class="col-sm-3">内容</div>
        <div class="col-sm-5">附带信息</div>
        <div class="col-sm-2">图片</div>
        <div class="col-sm-3">用户</div>
        <div class="col-sm-4">商户名</div>
        <div class="col-sm-1">操作</div>
      </div>
    </div>
    <div ref="dataList" class="data-list">
      <template v-if="list && list.length">
        <div v-for="item in list" :key="item.id" class="feedback-item-wraper">
          <div class="feedback-item row">
            <div class="col-sm-3">
              <label>反馈时间</label>
              <div>
                <ellipsis-text :content="item.createTime">{{ item.createTime | dateTimeFmt }}</ellipsis-text>
              </div>
            </div>
            <div class="col-sm-2">
              <label>类型</label>
              <div>{{ item.type | feedbackTypeFmt }}</div>
            </div>
            <div class="col-sm-3">
              <label>内容</label>
              <div>
                <ellipsis-text :content="item.content">{{ item.content }}</ellipsis-text>
              </div>
            </div>
            <div class="col-sm-5">
              <label>附带信息</label>
              <div><ellipsis-text :content="item.addon">{{ item.addon }}</ellipsis-text></div>
            </div>
            <div class="col-sm-2">
              <label>图片</label>
              <div>
                <el-image style="height: 28px" v-if="item.images && item.images.length" :src="item.images[0]" :preview-src-list="item.images"></el-image>
              </div>
            </div>
            <div class="col-sm-3">
              <label>用户</label>
              <div>{{ item.passportName }}</div>
            </div>
            <div class="col-sm-4">
              <label>商户名</label>
              <div>{{ item.companyName }}</div>
            </div>
            <div class="col-sm-1">
              <label>操作</label>
              <div>
                <el-button v-if="item.answer" type="text" size="mini" @click="showFeedback(item)">
                  查看
                </el-button>
                <el-button v-else type="text" size="mini" @click="doFeedback(item)">
                  反馈
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div v-else class="no-data">
        暂无数据~
      </div>
    </div>
    <div class="page-footer">
      <el-pagination
        background
        layout="prev, pager, next"
        :pager-count="5"
        :current-page.sync="pagination.pageIndex"
        :total="pagination.totalCount"
        :page-size="pagination.pageSize"
        @current-change="doLoad(false)"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { loadFeedBack, feedTypes } from './services'
import { bind, unbind } from '@/utils/eventBinder.js'
import _ from 'lodash'
export default {
  name: 'Feedback',
  filters: {
    feedbackTypeFmt (val) {
      const fdType = feedTypes.find(t => t.id === val)
      return (fdType && fdType.name) || '其他'
    }
  },
  data () {
    return {
      loading: false,
      fold: true,
      hasScroll: false,
      list: [],
      feedTypes,
      query: {
        keyword: undefined,
        companyName: undefined,
        type: undefined
      },
      pagination: {
        pageIndex: 1,
        pageSize: 30,
        totalCount: 0
      }
    }
  },
  computed: {
    renderRow () {
      return this.list.length
    },
    scrollBarWidth () {
      return this.$store.state.scrollbarWidth
    }
  },
  watch: {
    renderRow () {
      this.$nextTick(() => {
        this.checkScrollbar()
      })
    },
    newAdd () {
      this.doLoad(true)
    },
    area () {
      this.doLoad(true)
    }
  },
  mounted () {
    this.checkScrollBarDebounce = _.debounce(() => {
      this.checkScrollbar()
    }, 50)
    bind(window, 'resize', this.checkScrollBarDebounce)
    this.doLoad(true)
  },
  beforeDestory () {
    unbind(window, 'resize', this.checkScrollBarDebounce)
  },
  methods: {
    doLoad (reload) {
      if (reload) {
        this.pagination.pageIndex = 1
      }
      this.loading = true
      const { keyword, companyName, type } = this.query
      const { pageIndex, pageSize } = this.pagination
      loadFeedBack({
        keyword: keyword || undefined,
        companyName: companyName || undefined,
        type: type || undefined,
        newAdd: this.newAdd,
        area: this.area || undefined,
        pageIndex,
        pageSize
      }).then(resp => {
        const { items, pageIndex, pageSize, totalCount } = resp
        this.list = items
        this.pagination.pageIndex = pageIndex
        this.pagination.pageSize = pageSize
        this.pagination.totalCount = totalCount
      }).finally(() => {
        this.loading = false
      })
    },
    doReset () {
      this.query = {
        keyword: undefined,
        companyName: undefined,
        type: undefined
      }
      this.pagination = {
        pageIndex: 1,
        pageSize: 30,
        totalCount: 0
      }
      this.doLoad(true)
    },
    checkScrollbar () {
      const dataList = this.$refs.dataList
      if (dataList) {
        this.hasScroll = dataList.clientHeight < dataList.scrollHeight
      } else {
        this.hasScroll = false
      }
    },
    doFeedback (row) {
      this.modal('FeedbackModal', row).promise.then(result => {
        this.doLoad()
      }).catch(() => {})
    },
    showFeedback (row) {
      this.modal('FeedbackRespModal', row.answer).promise.catch(() => {})
    }
  }
}
</script>
